import React from "react";
import { Helmet } from "react-helmet-async";
import { motion } from "framer-motion";
import styles from "./LegalPages.module.css";

const fadeInUp = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy | Muigai Medical Center</title>
        <meta
          name="description"
          content="Privacy policy for Muigai Medical Center – how we protect your personal and medical information."
        />
      </Helmet>

      <section className={styles.heroBanner}>
        <div className={styles.heroOverlay}></div>
        <div className="container">
          <motion.div
            className={styles.heroContent}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeInUp}
          >
            <motion.div className={styles.sectionTag} variants={fadeInUp}>
              LEGAL
            </motion.div>
            <motion.h1 variants={fadeInUp}>Privacy Policy</motion.h1>
            <motion.p className={styles.heroSubtitle} variants={fadeInUp}>
              Your privacy is important to us.
            </motion.p>
          </motion.div>
        </div>
        <div className={styles.heroBackground}>
          <div
            className={styles.floatingCircle}
            style={{ top: "15%", left: "10%", width: "120px", height: "120px" }}
          />
          <div
            className={styles.floatingCircle}
            style={{
              bottom: "20%",
              right: "15%",
              width: "80px",
              height: "80px",
            }}
          />
          <div
            className={styles.floatingCircle}
            style={{ top: "60%", left: "20%", width: "60px", height: "60px" }}
          />
        </div>
      </section>

      <section className={styles.contentSection}>
        <div className="container">
          <div className={styles.contentCard}>
            <p>
              <strong>Last updated:</strong> {new Date().toLocaleDateString()}
            </p>

            <h2>1. Introduction</h2>
            <p>
              Muigai Medical Center ("we", "us", or "our") respects your privacy
              and is committed to protecting your personal data. This privacy
              policy explains how we collect, use, disclose, and safeguard your
              information when you visit our website or use our services.
            </p>

            <h2>2. Information We Collect</h2>
            <p>
              We may collect personal information that you voluntarily provide
              to us when you:
            </p>
            <ul>
              <li>Book an appointment</li>
              <li>Contact us via forms, email, or phone</li>
              <li>Use telemedicine services</li>
              <li>Subscribe to our newsletter</li>
            </ul>
            <p>
              This information may include your name, contact details, medical
              history (with consent), and any other data you choose to provide.
            </p>

            <h2>3. How We Use Your Information</h2>
            <p>We use the information we collect to:</p>
            <ul>
              <li>Provide medical services and appointment management</li>
              <li>Communicate with you about your health</li>
              <li>Improve our website and services</li>
              <li>Comply with legal and regulatory requirements</li>
            </ul>

            <h2>4. Sharing Your Information</h2>
            <p>
              We do not sell or rent your personal information to third parties.
              We may share your information with:
            </p>
            <ul>
              <li>Healthcare providers involved in your care</li>
              <li>
                Service providers who assist us (e.g., IT, payment processing)
                under strict confidentiality agreements
              </li>
              <li>Legal authorities when required by law</li>
            </ul>

            <h2>5. Data Security</h2>
            <p>
              We implement appropriate technical and organizational measures to
              protect your personal data against unauthorized access,
              alteration, disclosure, or destruction.
            </p>

            <h2>6. Your Rights</h2>
            <p>
              Depending on your location, you may have the right to access,
              correct, or delete your personal information. To exercise these
              rights, contact us at info@muigaiclinic.com.
            </p>

            <h2>7. Changes to This Policy</h2>
            <p>
              We may update this privacy policy from time to time. Any changes
              will be posted on this page with an updated effective date.
            </p>

            <h2>8. Contact Us</h2>
            <p>
              If you have questions about this privacy policy, please contact us
              at:
            </p>
            <address>
              Muigai Medical Center
              <br />
              P.O. Box 5687 00200, Nairobi, Kenya
              <br />
              Email: info@muigaiclinic.com
              <br />
              Phone: +254 722 265791
            </address>
          </div>
        </div>
      </section>
    </>
  );
};

export default PrivacyPolicy;
